import { type ReactNode } from "react";
interface PanelProps {
	children: ReactNode;
	title?: string;
}
export function Panel({ children, title }: PanelProps) {
	return (
		<div className="aa-panel">
			{title && (
				<div className="aa-panel__header">
					<h3 className={"h5"}>{title}</h3>
				</div>
			)}
			<div className="aa-panel__body">{children}</div>
		</div>
	);
}
